// extracted by mini-css-extract-plugin
module.exports = {"wrap":"src-pages-business-rizhao-__index__wrap--1VUQY","btn":"src-pages-business-rizhao-__index__btn--3oIrj"};